/*
 * humo-fixes.js — Humo Commerce
 * Защита от дублирования товара при быстрых нажатиях на «Добавить в корзину».
 *
 * Причина бага в assets/theme.js:
 *   1) опечатка getAttribute('disabled') вместо setAttribute — кнопка не блокируется;
 *   2) нет флага «запрос уже идёт» — параллельные POST /cart/add.js теряются;
 *   3) ajaxCart.init() перевешивает click-обработчики на те же кнопки без дедупликации.
 *
 * Решение не трогает theme.js: перехватываем клик на фазе погружения (capture)
 * — это раньше всех обработчиков на самой кнопке, сколько бы их ни навесили.
 */
(function () {
  'use strict';

  var SELECTOR = '.js-ajax-submit';
  var COOLDOWN = 900;      // мс между двумя осмысленными нажатиями
  var SAFETY_RELEASE = 8000; // мс — страховка, если запрос завис

  var inFlight = 0;
  var lastClick = 0;
  var lockedBtn = null;
  var safetyTimer = null;

  function lock(btn) {
    lockedBtn = btn;
    if (btn) {
      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('disabled');
      btn.setAttribute('aria-busy', 'true');
    }
    clearTimeout(safetyTimer);
    safetyTimer = setTimeout(unlock, SAFETY_RELEASE);
  }

  function unlock() {
    clearTimeout(safetyTimer);
    if (lockedBtn) {
      lockedBtn.removeAttribute('disabled');
      lockedBtn.classList.remove('disabled');
      lockedBtn.removeAttribute('aria-busy');
      lockedBtn = null;
    }
  }

  // Следим за запросами к корзине, чтобы снимать блокировку по факту, а не по таймеру.
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) { url = ''; }

      var isCartWrite = url.indexOf('/cart/add') !== -1 ||
                        url.indexOf('/cart/change') !== -1 ||
                        url.indexOf('/cart/update') !== -1;

      if (!isCartWrite) return nativeFetch.apply(this, arguments);

      inFlight++;
      var done = function () {
        inFlight = Math.max(0, inFlight - 1);
        if (inFlight === 0) setTimeout(unlock, 150);
      };
      return nativeFetch.apply(this, arguments).then(function (r) {
        done();
        return r;
      }, function (e) {
        done();
        throw e;
      });
    };
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!btn) return;

    var now = Date.now();
    var tooSoon = now - lastClick < COOLDOWN;

    if (inFlight > 0 || tooSoon || btn.hasAttribute('disabled')) {
      // Гасим повторное нажатие до того, как его увидят обработчики темы.
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }

    lastClick = now;
    lock(btn);
  }, true);

  // Если тема сама открыла мини-корзину — точно отпускаем кнопку.
  document.addEventListener('cart:updated', unlock);
  document.addEventListener('cart:refresh', unlock);
})();
